import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  



  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("🟢 Login button clicked");
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      console.log("📥 Response:", res.status, data);
if (!res.ok) {
  setMessage(data.error || "❌ Invalid email or password.");
  setLoading(false);
  return;
}

      // ✅ Successful login
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("userId", data.user.id);
      localStorage.setItem("userName", data.user.name);
      localStorage.setItem("isAdmin", data.user.role === "admin");

  setMessage("✅ Login successful! Redirecting...");
setTimeout(() => {
  if (data.user.role === "admin") {
    navigate("/admin-console");
  } else if (
    Number(data.user.licence_verified) !== 1 ||
    data.user.verified_id !== "Y"
  ) {
    navigate("/verify-licence");
  } else {
    navigate("/dashboard");
  }
}, 2000);
    } catch (err) {
      console.error("❌ Login error:", err);
      setMessage("⚠️ Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h2 style={headerStyle}>Sign In</h2>

        {message && (
          <div
            style={{
              ...messageStyle,
              color: message.includes("✅")
                ? "#2e7d32"
                : message.includes("⚠️")
                ? "#ff9800"
                : "#c62828",
              backgroundColor: message.includes("✅")
                ? "#e8f5e9"
                : message.includes("⚠️")
                ? "#fff8e1"
                : "#ffebee",
              borderColor: message.includes("✅")
                ? "#81c784"
                : message.includes("⚠️")
                ? "#ffcc80"
                : "#ef9a9a",
            }}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} style={formStyle}>
          <label style={labelStyle}>Email Address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            style={inputStyle}
          />

     <label style={labelStyle}>Password</label>

<div style={passwordWrapperStyle}>
  <input
    type={showPassword ? "text" : "password"}
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    required
    autoComplete="current-password"
    style={{ ...inputStyle, paddingRight: "45px" }}
  />

  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    style={eyeButtonStyle}
  >
    {showPassword ? <FaEyeSlash /> : <FaEye />}
  </button>
</div>

          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p style={footerText}>
          <a href="/forgot-password" style={linkStyle}>
            Forgot your password?
          </a>
        </p>

        <p style={footerText}>
          Don’t have an account?{" "}
          <a href="/signup" style={linkStyle}>
            Sign up
          </a>
        </p>
      </div>

      {/* Responsive + animation */}
      <style>
        {`
          @keyframes fadeSlide {
            from { opacity: 0; transform: translateY(-8px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @media (max-width: 600px) {
            div[style*="maxWidth: 400px"] {
              margin-top: 20px !important;
              padding: 20px !important;
            }

            body {
              overscroll-behavior: contain;
              background: #f8f9fa;
            }

            input {
              font-size: 16px;
            }

            button {
              font-size: 16px;
              padding: 14px;
            }
          }
        `}
      </style>
    </div>
  );
}

// ===== Styles =====
const containerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start", // ⬆️ Start higher
  minHeight: "100vh",
  background: "linear-gradient(to bottom, #f8f9fa, #eef3ee)",
  paddingTop: "60px", // ⬆️ Start higher on screen
  paddingBottom: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
};

const cardStyle = {
  width: "100%",
  maxWidth: "400px",
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  padding: "30px",
};

const headerStyle = {
  textAlign: "center",
  color: "#2e7d32",
  marginBottom: "25px",
};

const formStyle = { display: "flex", flexDirection: "column", gap: "15px" };

const labelStyle = {
  fontSize: "14px",
  color: "#333",
  marginBottom: "5px",
};

const inputStyle = {
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "14px",
  width: "100%",
};

const passwordWrapperStyle = {
  position: "relative",
  width: "100%",
};

const eyeButtonStyle = {
  position: "absolute",
  right: "12px",
  top: "50%",
  transform: "translateY(-50%)",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  fontSize: "18px",
  padding: 0,
  color: "#666",
  display: "flex",
  alignItems: "center",
};

const buttonStyle = {
  marginTop: "10px",
  padding: "14px",
  backgroundColor: "#2e7d32",
  color: "white",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "16px",
  transition: "background-color 0.3s ease",
};

const footerText = {
  textAlign: "center",
  marginTop: "15px",
  fontSize: "14px",
};

const linkStyle = {
  color: "#1976d2",
  textDecoration: "none",
  fontWeight: "500",
};

const messageStyle = {
  padding: "12px",
  borderRadius: "8px",
  textAlign: "center",
  marginBottom: "15px",
  border: "1px solid",
  animation: "fadeSlide 0.5s ease-out",
  fontWeight: "500",
  fontSize: "14px",
};

export default Login;
